import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function InformationIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M8 5.6V8m0 2.4h.006M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0" /></svg>
  );
}

export default InformationIcon;
